import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Cosodaotao from "components/Danhmuc/Cosodaotao/Cosodaotao.js";
export default function DmCosodaotao() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Cơ sở đào tạo lái xe",
            tabContent: <Cosodaotao />,
          },
        ]}
      />
    </div>
  );
}
